import { Outlet } from "react-router-dom";
import { CourseProvider } from "@/contexts/CourseContext";

export default function CourseLayout() {
	return (
		<CourseProvider>
			<Outlet />
		</CourseProvider>
	);
}
